import * as angular from "angular";
import {IController} from "angular";
import {$addressesFactory} from "../../$addresses.factory";

export class AddressesResolverListCtrl implements IController {

  quality: any;
  queryString: any;
  selectedAddress: any;
  doReload: any;
  isResolved: boolean;

  onReload: Function;
  onSelect: Function;
  onEdit: Function;

  private infiniteScroll: any;
  private addressesRef: any;
  private loadLimit: number;

  /* @ngInject */
  constructor(private $infiniteScroll, private $addresses: $addressesFactory) {
    this.addressesRef = this.$addresses();
  }

  $onInit() {
    this.loadLimit = 30;
    this.addressesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.addressesRef, this.loadLimit, {getFullData: true});
  };

  $onChanges(changes) {

    if (changes.quality && !changes.quality.isFirstChange() ||
      changes.queryString && !changes.queryString.isFirstChange() ||
      changes.isResolved && !changes.isResolved.isFirstChange()) {

      this.addressesRef.$query(this._getQueryPayload());
      this._doReload();
    }

    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (this.doReload) {
        this._doReload();
        this.onReload();
      }
    }

  };

  private _doReload() {
    this.addressesRef.cursor = null;
    this.infiniteScroll.reload();
  }

  private _getQueryPayload() {
    return {
      searchTerm: this.queryString,
      quality: this.quality,
      limit: this.loadLimit,
      resolved: this.isResolved
    };
  }


}

angular
  .module('bringoz.admin.addresses')
  .component('addressesResolverList', {
    bindings: {
      quality: '<',
      queryString: '<',
      isResolved: '<?',
      selectedAddress: '<',
      doReload: '<',
      onReload: '&',
      onSelect: '&',
      onEdit: '&'
    },
    template: require('./addresses-resolver-list.html').default,
    controller: AddressesResolverListCtrl
  });
